export default class Vaccine {
  done?: boolean;
  name: string;
  vaccinationDate?: Date;

  constructor(name: string, done?: boolean, vaccinationDate?: Date) {
    this.name = name;
    this.done = done;
    if (!vaccinationDate) return;
    this.vaccinationDate = new Date(vaccinationDate);
  }

  serialize(): { name: string; done?: boolean; vaccinationDate?: string } {
    return {
      name: this.name,
      done: this.done,
      vaccinationDate: this.vaccinationDate?.toISOString()
    };
  }
}
